import skygear from 'skygear';

const AlbumPhoto = skygear.Record.extend('album_photo');

export default function getAlbumPhotos() {
  const query = new skygear.Query(AlbumPhoto);
  query.addDescending('position');
  query.addDescending('_created_at');
  query.limit = null;
  return skygear.publicDB.query(query);
}



// WEBPACK FOOTER //
// ./src/models/AlbumPhoto.js